export const triggersActionType = {
  addTriggers: "AddTriggers",
  removeTriggers: "RemoveTriggers",
  editTriggers: "EditTriggers",
};
